/**
 * TABLO SAYFALAMA — TEK STANDART. Yeni bir tabloya sayfalama eklerken kendi tasarımını YAZMA, bunu kullan.
 * - `TablePager`  : masaüstü tablo altı (referans tasarım `.dt2-foot` + `.pager`/`.pg`) — her zaman görünür
 *                   (toplam kayıt + sayfa göstergesi), tek sayfada da "1 / 1" basar.
 * - `MobilePager` : mobil liste altı (referans `btn-md secondary sm` ‹ Önceki / Sonraki ›) — tek sayfada gizlenir.
 * `.dt2-foot` stilleri `pages/Items.css`, `.m-pager` stilleri global `styles/mobile.css` içindedir.
 */

interface PagerProps {
  page: number;
  totalPages: number;
  onPage: (page: number) => void;
}

/** Masaüstü tablo sayfalama (referans tasarım). `unit` = "sevkiyat" / "sipariş" gibi kayıt adı. */
export function TablePager({ total, unit, page, totalPages, onPage }: PagerProps & { total: number; unit: string }) {
  return (
    <div className="dt2-foot">
      <div><b>{total}</b> {unit}</div>
      <div className="pager">
        <button type="button" className="pg" aria-label="Önceki sayfa" onClick={() => onPage(Math.max(1, page - 1))} disabled={page <= 1}>‹</button>
        <span className="pg active">{page}</span>
        <span className="pg-sep">/ {totalPages}</span>
        <button type="button" className="pg" aria-label="Sonraki sayfa" onClick={() => onPage(Math.min(totalPages, page + 1))} disabled={page >= totalPages}>›</button>
      </div>
    </div>
  );
}

/** Mobil liste sayfalama (referans tasarım). Tek sayfa varsa hiç render edilmez. */
export function MobilePager({ page, totalPages, onPage }: PagerProps) {
  if (totalPages <= 1) return null;
  return (
    <div className="m-pager">
      <button type="button" className="btn-md secondary sm" disabled={page <= 1} onClick={() => onPage(Math.max(1, page - 1))}>‹ Önceki</button>
      <span className="mono m-pager-lbl">{page} / {totalPages}</span>
      <button type="button" className="btn-md secondary sm" disabled={page >= totalPages} onClick={() => onPage(Math.min(totalPages, page + 1))}>Sonraki ›</button>
    </div>
  );
}
